<template>
     <el-dialog
        :title="$t('DomesticTransportation.hint')"
        :visible.sync="dialogVisible"
        width="500px"
        custom-class="subscription-success-dialog"
        >
        <div style="text-align: center;">
            <img src="@/assets/tms/finish.png" style="width: 40px;height: 40px;"/>
            <div style="margin-top: 8px;font-size: 16px;font-weight: 600;">{{ $t('DomesticTransportation.SubscribeSuccessfully') }}</div>
            <div style="margin-top: 16px;font-size: 14px;color:gray">{{ $t('DomesticTransportation.description') }}</div>
        </div>
     </el-dialog>

</template>
<script>
import i18n from '@/i18n/i18n'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    }
  },
}
</script>
<style lang="less">
.subscription-success-dialog {
    height: 50vh;
}
</style>
